import { useState } from 'react'
import { useLocation, useOutlet } from 'react-router-dom'
import { DashboardActivityContext } from '../dashboard/DashboardActivityContext.js'

// Owned by the authenticated shell, keyed by user. Other pages retain normal
// route lifetimes; the dashboard first mounts only when actually visited.
export default function RetainedDashboardOutlet() {
  const outlet = useOutlet()
  const active = useLocation().pathname.replace(/\/$/, '') === '/dashboard'
  const [dashboard, setDashboard] = useState(() => active ? outlet : null)
  if (active && !dashboard && outlet) setDashboard(outlet)
  return <>
    {dashboard && <div hidden={!active} inert={active ? undefined : ''}
      data-testid="retained-dashboard"
      className={active ? 'flex min-h-0 flex-1 flex-col' : 'hidden'}>
      <DashboardActivityContext.Provider value={active}>{dashboard}</DashboardActivityContext.Provider>
    </div>}
    {!active && outlet}
  </>
}
